import React from 'react';
import '../styles/Project.css'; // external CSS file

const Project = () => {
  return (
    <div className="project-container">
      <h2>Name: New Project</h2>
      <p className="project-updated">Project Roadmap V1.0 | Last edited 12:43 PM</p>

      {/* Project Vision/Goal */}
      <section className="project-section">
        <h3>Project Vision/Goal</h3>
        <p>The Note Bar is aimed at revolutionizing how we interact with technology for learning and application of knowledge to completing tasks.</p>
      </section>

      {/* Phases */}
      <section className="project-section">
        <h3>PHASE 1</h3>
        <p>Complete Bubble front end, create database in Bubble, connect database to pipeline.</p>
        <h3>PHASE 2</h3>
        <p>Test success coach agent outputs routed to database, outputs routed to front end.</p>
        <h3>PHASE 3</h3>
        <p>Complete Bubble front end, create database in Bubble, connect database to pipeline.</p>
      </section>

      {/* Teams */}
      <section className="project-section">
        <h3>Teams</h3>
        <div className="project-teams">
          <div className="project-team">
            <strong>Engineering</strong>
            <p>Match deliverable to phase and milestones.</p>
          </div>
          <div className="project-team">
            <strong>Engineering</strong>
            <p>Match deliverable to phase and milestones.</p>
          </div>
          <div className="project-team">
            <strong>Engineering</strong>
            <p>Match deliverable to phase and milestones.</p>
          </div>
        </div>
      </section>

      {/* Key Deliverables */}
      <section className="project-section">
        <h3>Key Deliverables</h3>
        <ul>
          <li>1. Complete Note Bar MVP</li>
          <li>2. Develop GTM strategy with I-Corps Research</li>
          <li>3. After showing cash flow, raise capital for growth in FY25</li>
        </ul>
      </section>

      {/* Milestones and Timeline */}
      <div className="project-timeline-container">
        <div>
          <h3>Milestones</h3>
          <div className="project-chart-placeholder">[Chart Placeholder]</div>
        </div>
        <div>
          <h3>Timeline</h3>
          <div className="project-timeline-placeholder"></div>
        </div>
      </div>
    </div>
  );
};

export default Project;
